import { useContext } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import BackButton from "../../../../components/Button/BackButton";
import DetailsPage from "./Details/DetailsPage";
import FilesPage from "./Files/FilesPage";
import FinancePage from "./Finances/FinancePage";
import JobsPage from "./Jobs/JobsPage";
import { AuthContext } from "../../../../context/AuthContext";
import { isFreelance } from "../../../../utils/constants/accountType";

const ProjectDetailPage = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useContext(AuthContext);
  // Jobs are enterprise-only; freelance accounts don't get the Jobs tab.
  const freelance = isFreelance(user);

  // Jobs tab is removed for freelance accounts.
  const tabs = ["Details", "Files", ...(freelance ? [] : ["Jobs"]), "Workflow", "Finances"];

  const activeTab = searchParams.get("tab") || "details";

  const setTab = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <>
      <div className="border-b mb-6 flex items-end gap-4">
        <BackButton label={null} className="mb-1.5 -ml-1.5" />
        <div className="h-5 w-px bg-gray-200 mb-2 self-center" />
        <div className="flex space-x-5 overflow-x-auto">
          {tabs.map((tab) => {
            const key = tab.toLowerCase().replace(" ", "");

            return (
              <button
                key={tab}
                className={`pb-2 text-sm text-gray-600 border-b-2 transition whitespace-nowrap ${
                  activeTab === key
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent hover:text-gray-900 hover:border-gray-300"
                }`}
                onClick={() => setTab(key)}
              >
                {tab}
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === "details" && <DetailsPage projectId={id} />}
      {activeTab === "files" && <FilesPage projectId={id} />}
      {activeTab === "finances" && <FinancePage projectId={id} />}
      {activeTab === "jobs" && !freelance && <JobsPage projectId={id} />}
      {/*
      {activeTab === "Workflow" && <WorkflowPage projectId={id} />}
      {activeTab === "CAT Logs" && <CatLogsPage projectId={id} />} */}
    </>
  );
};

export default ProjectDetailPage;
